import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
declare var $: any;

@Component({
  selector: 'app-manage-treatments',
  templateUrl: './manage-treatments.component.html',
  styleUrls: ['./manage-treatments.component.css']
})
export class ManageTreatmentsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage:number=25;treatmentList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100,200];pageIndex:number=0;loaded:boolean=false;treatCategory=[];treatCategory_copy=[];
    search:string;currentUserId:any;sc3Url='';treatment_category_filter='';

    constructor(private sharedapi:SharedService,public miscapi:MiscService) { }

    ngOnInit(): void
    {
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.currentUserId = localStorage.getItem('loginuserId');
        this.sc3Url = localStorage.getItem('s3url');
        this.getTreatmentCategory();
    }

    ngAfterViewInit() {
         this.loadTreatmentList(0,this.perpage);
    }

    async loadTreatmentList(pageIndex,perpage)
    {
    	this.treatmentList = [];
      this.paginator.pageIndex = pageIndex;
    	let qString = 'search='+this.search+'&treatment_category_filter='+this.treatment_category_filter;
        this.loading = true;this.loaded = false;
        await this.miscapi.getTreatmentList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.treatmentList = data.data;
            }else{
                this.treatmentList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadTreatmentList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadTreatmentList(event.pageIndex,event.pageSize);
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
                this.treatCategory_copy = this.treatCategory;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    setSearchValue(type){
        if(type=='treatmentCategory'){
            $("#treatmentCategorySearch").val('');
            $("#treatmentCategorySearch").focus();
            this.treatCategory= this.treatCategory_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
       if (type == 'treatmentCategory') {
        this.treatCategory = this.sharedapi.searchData(searchtText, this.treatCategory_copy, "name");
       }
    }
    resetFilters(){
        this.search = ''; this.treatment_category_filter='';
        this.loadTreatmentList(0,25);
    }
}
